// extracted by mini-css-extract-plugin
module.exports = {"root":"BKBUvdSG","titleLabel":"fe8QnTek","descriptionLabel":"_BkX_Wbe","tableWrapper":"UkQKtvyt","expanded":"D_hJV3l6","filterWrapper":"LNRCEcoB","viewMoreWrapper":"btkyfEzM"};